import {
  userStatus,
  envConfig
} from '../_helpers';

export const analyticsService = {
  countNotifications,
  countNotificationsDashboard,
  countUsersByBrowser,
  countUsersByCity,
  countUsersByCountry,
  countUsersByOs,
  countUsersByRegion,
  conversionCount,
  notificationConversionCountByMomentum,
  countVisitsByMomentum,
  countMomentums,
  originCount,
  countPersons,
  visitCount,
  prospectCount
}

const user = userStatus();

const getRequestOptions = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.bearer_token}`
  }
}

const req = async(url) => {
  const response = await fetch(url, getRequestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Count amount of notifications sent
async function countNotifications(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/notification/count`);
}

// Count users and notifications sent
async function countNotificationsDashboard(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/notification/count/dashboard`);
}

// Count users by browser
async function countUsersByBrowser(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/person/count/browser`);
}

// Count users by city
async function countUsersByCity(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/person/count/city`);
}

// Count users by country
async function countUsersByCountry(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/person/count/country`);
}

// Count users by OS
async function countUsersByOs(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/person/count/os`);
}

// Count users by region
async function countUsersByRegion(domain_uuid) {
  return await req(`${envConfig.MOMENTUM_API_URL}/analytics/domain/${domain_uuid}/person/count/region`);
}

// Conversion count
async function conversionCount(company_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/conversion`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Count notifications convertions by momentum
async function notificationConversionCountByMomentum(company_uuid, momentum_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/momentum/${momentum_uuid}/notification_conversion`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Count visits by momentum
async function countVisitsByMomentum(company_uuid, momentum_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/momentum/${momentum_uuid}/visited`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Count momentums
async function countMomentums(company_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/momentum`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Count origins
async function originCount(company_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/origin`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Person count by company
async function countPersons(company_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Count persons per visit
async function visitCount(company_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/visited`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

// Prospect count
async function prospectCount(company_uuid, data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`
    },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/analytics/company/${company_uuid}/person/count/visited_prospect`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}